import React from 'react';

import { useBreadcrumbs } from '../../common/providers/BreadcrumbProvider';
import UiPageContainer from '../common/UiPageContainer/UiPageContainer';
import AdminBreadCrumbs from '../organizationsettings/AdminBreadCrumbs';
import { GovernanceStepperComponent } from './GovernanceStepperComponent';

const GovernanceCreateComponent = () => {
    const { breadcrumbs } = useBreadcrumbs();

    return (
        <UiPageContainer
            breadcrumb={<AdminBreadCrumbs breadCrumbTrail={breadcrumbs} />}
            position="left"
        >
            <GovernanceStepperComponent />
        </UiPageContainer>
    );
};

export default GovernanceCreateComponent;
